if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          // Update the text display for selected swatch value
          const optionName = target.name.match(/options\[([^\]]+)\]/);
          if (optionName && optionName[1]) {
            const selectedSwatchValueText = target
              .closest('.product-form__input')
              .querySelector('[data-selected-swatch-value="' + optionName[1] + '"]');
            if (selectedSwatchValueText) {
              selectedSwatchValueText.textContent = value;
              selectedSwatchValueText.setAttribute('data-selected-variant-value', value.replace(/ /g, ''));
            }
          }

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) {
            // Update cm conversion even if no swatch
            if (optionName && optionName[1]) {
              this.updateCmConversion(optionName[1], value);
            }
            return;
          }
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );

          // Update cm conversion after swatch update
          if (optionName && optionName[1]) {
            this.updateCmConversion(optionName[1], value);
          }
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;

          // Update cm conversion for radio buttons
          const optionName = target.name.match(/options\[([^\]]+)\]/);
          if (optionName && optionName[1]) {
            const selectedSwatchValueText = target
              .closest('.product-form__input')
              .querySelector('[data-selected-swatch-value="' + optionName[1] + '"]');
            if (selectedSwatchValueText) {
              selectedSwatchValueText.textContent = value;
              selectedSwatchValueText.setAttribute('data-selected-variant-value', value.replace(/ /g, ''));
            }
            this.updateCmConversion(optionName[1], value);
          }
        }
      }

      // Convert feet'inches" to cm
      feetInchesToCm(value) {
        if (!value) return 0;
        const match = value.match(/(\d+)'(\d+)"/);
        if (!match) return 0;
        const feet = parseInt(match[1], 10);
        const inches = parseInt(match[2], 10);
        return Math.round((feet * 30.48) + (inches * 2.54));
      }

      // Update cm conversion display
      updateCmConversion(optionName, value) {
        const cmEl = this.querySelector('[data-cm-conversion="' + optionName + '"]');
        if (!cmEl) return;

        // Parse value like "2'7" x 3'3""
        const parts = value.split(' x ');
        if (parts.length !== 2) return;

        const dim1Cm = this.feetInchesToCm(parts[0].trim() + '"');
        const dim2Cm = this.feetInchesToCm(parts[1].trim());

        if (!dim1Cm || !dim2Cm) return;

        const cmValue = dim1Cm + ' x ' + dim2Cm + ' cm';
        
        // Update attribute
        cmEl.setAttribute('data-conversion-value', cmValue);
        cmEl.setAttribute('data-original-value', value);
        
        // Update text with approximate symbol
        const cmValueEl = cmEl.querySelector('[data-cm-value]');
        if (cmValueEl) {
          cmValueEl.textContent = '≈ ' + cmValue;
        }
      }
    }
  );
}
